export default "__VITE_ASSET__BzewSq_p__"